import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";
import { CheckCircle2, Landmark } from "lucide-react";

function generateFolio() {
  const now = new Date();
  const y = now.getFullYear();
  const rnd = Math.floor(100000 + Math.random() * 899999);
  return `NRV-${y}-${rnd}`;
}

export default function ThankYou() {
  const { tMx } = useI18n();
  const checklist = tMx("thankyou.checklist") || [];
  const folio = useMemo(generateFolio, []);

  return (
    <main
      data-testid="thankyou-page"
      className="min-h-[80vh] bg-[#FAF9F5] flex items-center justify-center py-16 px-4"
    >
      <div className="max-w-2xl w-full bg-white rounded-2xl border border-slate-200 shadow-xl p-8 sm:p-10 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 text-emerald-700">
          <CheckCircle2 size={36} strokeWidth={2.2} />
        </div>
        <span className="mt-6 inline-block text-xs font-bold uppercase tracking-widest text-emerald-800 bg-emerald-100 px-3 py-1 rounded-md">
          {tMx("thankyou.eyebrow")}
        </span>
        <h1 className="mt-4 font-serif text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight">
          {tMx("thankyou.title")}
        </h1>
        <p className="mt-4 text-slate-600 text-base leading-relaxed">
          {tMx("thankyou.subtitle")}
        </p>

        <ul className="mt-8 text-left space-y-3">
          {checklist.map((item, i) => (
            <li
              key={i}
              data-testid={`thankyou-check-${i}`}
              className="flex gap-3 items-start text-sm text-slate-700"
            >
              <CheckCircle2
                size={18}
                className="text-emerald-600 mt-0.5 shrink-0"
              />
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <div className="mt-8 flex items-center justify-center gap-2 text-xs uppercase tracking-widest text-slate-500">
          <Landmark size={14} className="text-[#C5A059]" />
          <span>
            {tMx("thankyou.reference")}: <strong>{folio}</strong>
          </span>
        </div>

        <Link
          to="/"
          data-testid="thankyou-back-home"
          className="mt-8 inline-flex items-center justify-center bg-[#0F2C59] hover:bg-[#153a75] text-white font-semibold px-6 py-3 rounded-md text-sm"
        >
          {tMx("thankyou.back")}
        </Link>
      </div>
    </main>
  );
}
